import { useApiClientStore } from '../stores/useApiClientStore';

import { ApiResult } from '../types';
import { MedicalRequest } from '../types/medical-request';

export async function submitMedicalRequestApi(payload: MedicalRequest): Promise<ApiResult> {
  const api = useApiClientStore().getClient();

  const fd = new FormData();

  fd.append('proxyDetails[firstName]', payload.proxyDetails?.firstName ?? '');
  fd.append('proxyDetails[lastName]', payload.proxyDetails?.lastName ?? '');
  fd.append(
    'proxyDetails[relationshipToPatient]',
    payload.proxyDetails?.relationshipToPatient ?? '',
  );
  fd.append('reporterType', payload.reporterType);

  fd.append('problemDescription', payload.problemDescription ?? '');
  fd.append('problemRecentContact', payload.problemRecentContact ?? '');

  // actual attachments
  for (const file of payload.attachments ?? []) {
    fd.append('attachments[]', file, file.name);
  }

  return api.postRawFiles<ApiResult>('/patient-portal/medical-request', fd);
}
